module.exports = __webpack_public_path__ + "img/phone.eb9b471f.svg";